import React from 'react';

const Logout = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.25929 12.7407L3.25929 3.25924"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.00002 10.4889L5.51113 8L8.00002 5.51111"
        stroke="#787F88"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M5.62963 8H12.7407" stroke="#787F88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  );
};

export default Logout;
